<template>
  <div class="box20">
    <div class="left">
      <div class="title">AI+Python大数据学习线路图</div>
      <div class="tag-box">
        <div class="tag">自学必看</div>
        <div class="tag">零基础</div>
        <div class="tag">新版</div>
      </div>
      <div class="btn" @click="zixun('免费领取')">免费领取</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    zixun(e) {
     this.mai("Python+大数据","免费领取",0,null)
    this.clickZiXun()
      
    },
  },
};
</script>

<style lang="less" scoped>
.box20 {
  padding-top: 20px;
  padding-left: 50px;
  width: 100%;
  height: 230px;
  background: url("../../../assets/coursePage/pythonData/footer.png") no-repeat;
  background-size: cover;
  box-sizing: border-box;

  .left {
    .title {
      margin-bottom: 20px;
      font-family: PingFangSC-Semibold;
      font-size: 40px;
      font-weight: bold;
      color: #fafbff;
    }
    .tag-box {
      display: flex;
      align-items: center;
      .tag {
        margin-right: 18px;
        padding: 0px 22px;
        // width: 109px;
        height: 32px;
        background-color: rgba(255, 255, 255, 0.2);
        border-radius: 15px;
        text-align: center;
        font-family: PingFang SC;
        font-size: 24px;
        font-weight: normal;
        line-height: 31px;
        color: #ffffff;
      }
    }

    .btn {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 25px;
      width: 150px;
      height: 46px;
      background-color: #ffffff;
      border-radius: 10px;
      text-align: center;
      font-family: PingFangSC-Semibold;
      font-size: 24px;
      font-weight: bold;

      letter-spacing: 1px;
      color: #006aff;
    }
  }
}
</style>
